import { AxiosResponse } from "axios";
import { API_PREFIX, API_VERSION, Command, HttpVerbType } from "../Command";
import { GetBranchReportReqData } from "./GetBranchReportReqData";

const ENDPOINT = "/cash_flow/branch_report/download";

export class DownloadBranchReportCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "get";
    params: any = null;

    constructor(params: GetBranchReportReqData, exportType: string, lang: string) {
        super();
        this.params = { exportType, lang, ...params };
        this.responseType = exportType == "pdf" ? "blob" : "text";
    }

    public async execute(): Promise<AxiosResponse> {
        return await this.executeCommand(null, null, this.params);
    }
}
